// import { isValidNumber } from 'libphonenumber-js';
// import * as EmailValidator from 'email-validator';

// window.isValidNumber = isValidNumber;

const inputRules = {
    required: value => !!value || window.app.$t('core.required_field'),
    counter: value => value.length <= 20 || 'Max 20 characters',

    checkboxGroupRequired: (value) => {
        return (value!==null && Array.isArray(value) && value.length > 0);
    },

    requiredYesNo: (value) => {
        return (value!==null);
    },

    exactLength: (value, len) => {
        return ((value.length === 0 || value.length === len) || window.app.$t('validator.invalid_length'));
    },

    email: value => {
        return true;
        //const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        //return (typeof(value)==='undefined' || value === null || value === '' || EmailValidator.validate(value)) || window.app.$t('validator.invalid_email')
    },

    phone: value => {
        return true;
        //if(typeof(value)==='undefined' || value === null || value === '') return true;
        //return (typeof(value)==='undefined' || value === null || (typeof value === 'string' && (value.length<1 || window.isValidNumber(value)))) || window.app.$t('validator.invalid_phone')
    }
};

const PM_inputRules = {};
PM_inputRules.install = function (Vue, options) {
    Vue.prototype.$inputRules = inputRules;
    Vue.inputRules = inputRules;
};

export default PM_inputRules;
